<template>
  <div class="search">
    <div class="nwrap">
      <div class="nei_ban" >
        <h3>{{$t('m.search')}}<p></p></h3>
      </div>
      <div class="clear ptb3"></div>
      <div class="mainbox wrap">
        <div class="news_l">
          <div class="nw_list">
            <dl v-for="(item,index) in listData" :key="index">
              <a v-if="item.url && item.url !== ''" :href="item.url">
                <dt>
                  <img v-if="item.thumb1 && item.thumb1!= '' " :src="item.thumb1">
                  <img v-else src="../assets/image/16566653257874.jpeg">
                </dt>
                <dd>
                  <h3 v-html="item.title"></h3>
                  <h5>{{ dayjs(item.publishDate).format('YYYY-MM-DD HH:mm') }}</h5>
                  <p v-html="item.artDesc"></p>
                </dd>
              </a>
              <a v-else :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                <dt>
                  <img v-if="item.thumb1 && item.thumb1!= '' " :src="item.thumb1">
                  <img v-else src="../assets/image/16566653257874.jpeg">
                </dt>
                <dd>
                  <h3 v-html="item.title"></h3>
                  <h5>{{ dayjs(item.publishDate).format('YYYY-MM-DD HH:mm') }}</h5>
                  <p v-html="item.artDesc"></p>
                </dd>
              </a>
              <div class="clear"></div>
            </dl>
          </div>
          <div class="listpagination" v-if="listData.length!=0">
            <el-pagination 
              layout="prev, pager, next" 
              :current-page="pageNum" 
              :page-size="pageSize" 
              :total="total" 
              :pager-count="7" 
              @current-change="currentChange" 
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { articleSearch , getCookie } from '@/api/common'

export default {
  name: 'list',
  data(){
    return {
      slideHdTitle: '',
      viewSlideHdParent: false,
      slideHdParentName: '',
      slideHdParentUrl: '',
      slideHdName: '',
      searchValue:'',
      pageCont: '',
      active: 0,
      slideHd: {
        title: '新闻动态',
      },
      slideList:[],
      listData: [],
      pageSize: 5,
      pageNum: 1,
      total: 0,
      listId: '',
      applicationUuid:'',
      lang: 'zh-CN',
    }
  },
  mounted(){
    var _this = this

    let lang = getCookie('lang')
    if( lang == 'en-US'){
      this.applicationUuid = this.webIdEn
    }
    else {
      this.applicationUuid = this.webId
    }

    _this.searchValue = _this.$route.params.title
    _this.articles()
  },
  methods: {
    // 获取列表
    articles() {
      var _this = this
      let data = {
        title: _this.$route.params.title,
        pageNum: _this.pageNum,
        pageSize: _this.pageSize,
        entTApplicationUuid: this.applicationUuid,
      }
      articleSearch(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.listData = data.rows
          _this.total = data.totalRows
          if(_this.searchValue != ' '){
            for(let i in _this.listData) {
             //高亮替换
             _this.listData[i].title = this.showData(_this.listData[i].title)
             _this.listData[i].artDesc = this.showData(_this.listData[i].artDesc)
            }
          }
        }
      })
    },
    // 筛选变色 如果搜索结果记录包含关键字，那么修改样式
    showData(val) {
      if (this.checkParam(val,this.searchValue)) {
      //以 关键词 去分隔字符串 形成一个数组
        let arrry = val.split(this.searchValue)
        
        //把数组元素用固定分隔符（此处为已添加高亮的关键词）拼接为一个完整字符串
        val = arrry.join('<span style="color: #FF0000;">' + this.searchValue + '</span>');
        
        return val
      } 
      else {
        return val //不做任何修改
      }
    },
    //判断搜索记录是否包含某个关键字
    checkParam(val,param){
      // 判断在标题中是否存在关键字，如果要检索的字符串值没有出现，则该方法返回 -1。
      if (val.indexOf(param) !== -1 && param !== ''){
        return true;
      }else {
        return false
      }
    },

    currentChange(e){
      var _this = this
      _this.pageNum = e
      _this.articles()
    }
  }
}
</script>
<style>

.search .nei_ban {
  clear: both;
  width: 100%;
  height: 270px;
  background: url(../assets/image/1-200429120106245.jpeg);
}
.search .nei_ban {
  background-size: cover!important;
}
.search .nei_ban h3 {
  text-align: center;
  width: 100%;
  clear: both;
  font-size: 48px;
  color: #fff;
  font-weight: normal;
  padding-top: 105px;
}
.search .nei_ban p {
  font-size: 24px;
  color: #fff;
  text-transform: uppercase;
}
.search .clear {
  height: 0;
  clear: both;
  zoom: 1;
}
.search .ptb3 {
  padding-top: 3%;
}
.search .wrap {
  width: 1200px;
  margin: 0 auto;
}
.search .news_l {
  width: 90%;
  margin: 0 auto;
}
.search .news_cl {
  clear: both;
  width: 100%;
}
.search .nw_list {
  clear: both;
  width: 100%;
}
.search .nw_list dl {
  clear: both;
  border-bottom: 1px #dcdcdc solid;
  padding: 30px 0;
}
.search .nw_list dl dt {
  float: left;
  width: 25%;
}
.search .nw_list dl dt img {
  width: 100%;
  height: 100%;
}
.search img {
  max-width: 100%;
}
.search .nw_list dl dd {
  float: right;
  width: 71%;
}
.search .nw_list dl dd h3 {
  font-size: 18px;
}
.search .nw_list dl dd h5 {
  font-weight: normal;
  font-size: 12px;
  color: #999999;
  padding: 10px 0;
}
.search .nw_list dl dd p {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  line-height: 26px;
}
.search .listpagination{
margin: 20px auto;
text-align: center;
}
@media (max-width: 1400px) {
.search .wrap {
  box-sizing: border-box;
  width: 100%;
  padding: 0 15px;
}
}
@media (max-width: 768px) {
.search .wrap {
  box-sizing: border-box;
  width: 100%;
  padding: 0 15px;
}
.search .news_l {
  width: 100%;
}
.search .news_cl li a {
  font-size: 18px;
}
.search .nw_list dl dt {
  width: 35%;
}
.search .nw_list dl dd h3 {
  font-size: 14px;
}
.search .nw_list dl dd {
  width: 60%;
}
.search .nw_list dl dd p {
  display: none;
}
}
</style>